import React from "react";
import "./ArrayProperty.css"; // CSS منفصل للستايل الاحترافي

function ArrayProperty() {
  const reasons = [
    { title: "خبرة هندسية", desc: "سنوات من الخبرة في التشطيبات السكنية والتجارية بأعلى معايير الجودة." },
    { title: "التزام كامل", desc: "نلتزم بالمواعيد والخطط الزمنية دون أي تأخير." },
    { title: "خامات معتمدة", desc: "نستخدم خامات موثوقة تضمن تشطيب يدوم لسنوات." },
    { title: "تنفيذ احترافي", desc: "فريق متخصص يشرف على كل مرحلة من مراحل التنفيذ." },
    { title: "شفافية تامة", desc: "عقود واضحة وتسعير عادل بدون أي مفاجآت." },
    { title: "رضا العملاء", desc: "ثقة عملائنا هي أكبر شهادة نجاح لنا." }
  ];

  return (
    <section className="why-legend py-5">

      {/* HERO */}
      <div className="why-hero text-center mb-5">
        <h1>لماذا تختارنا؟</h1>
        <p>نحن لا ننفذ تشطيبات فقط… نحن نبني ثقة تدوم</p>
      </div>

      {/* STATS */}
      <div className="container stats-section text-center mb-5">
        <div className="row">
          <div className="col-md-3 col-6 stat-box">
            <h3>20+</h3>
            <span>سنوات خبرة</span>
          </div>
          <div className="col-md-3 col-6 stat-box">
            <h3>250+</h3>
            <span>مشروع منفذ</span>
          </div>
          <div className="col-md-3 col-6 stat-box">
            <h3>90%</h3>
            <span>التزام بالمواعيد</span>
          </div>
          <div className="col-md-3 col-6 stat-box">
            <h3>98%</h3>
            <span>رضا العملاء</span>
          </div>
        </div>
      </div>

      {/* REASONS CARDS */}
      <div className="container reasons-section">
        <div className="row">
          {reasons.map((item, i) => (
            <div key={i} className="col-lg-4 col-md-6 mb-4">
              <div className="legend-card p-4 shadow-sm rounded text-center position-relative">
                <span className="legend-number">{i + 1}</span>
                <h5 className="mt-3">{item.title}</h5>
                <p className="mt-2">{item.desc}</p>
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* PROCESS */}
      <div className="process-section text-center my-5">
        <h2 className="mb-4">آلية العمل</h2>
        <div className="process-steps d-flex justify-content-center flex-wrap gap-3">
          <div className="process-step">المعاينة</div>
          <div className="process-step">التصميم</div>
          <div className="process-step">التنفيذ</div>
          <div className="process-step">التسليم</div>
        </div>
      </div>

      {/* CTA */}
      <div className="legend-cta text-center mt-5">
        <h3>جاهز تبدأ مشروعك مع فريق موثوق؟</h3>
        <p>تواصل معنا الآن ودعنا ننفذ مشروعك باحتراف</p>
        <a href="/contact" className="legend-btn btn-primary">ابدأ الآن</a>
      </div>

    </section>
  );
}

export default ArrayProperty;
